<div class="trigger-and-artifact">
    <mat-card-header>
        <h2>Trigger and artifact configuration</h2>
    </mat-card-header>

    <form [formGroup]="triggerForm">
        <mat-card class="trigger-artifact-card">
            <div class="row-box">
                <div class="left-box">
                    <mat-form-field appearance="fill" class="child-content readonly-wrapper"
                        [ngClass]="{'disabled-cursor': triggerForm.disabled}">
                        <mat-label [ngClass]="{'disabled-cursor': triggerForm.disabled}">Organization</mat-label>
                        <input matInput [matAutocomplete]="org" formControlName="repoOwner" required
                            (focus)="onInputFocus('org')">
                        <mat-autocomplete #org="matAutocomplete">
                            <mat-option *ngFor="let org of filteredOrganizations" [value]="org">
                                {{ org }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="triggerForm.get('repoOwner')?.hasError('required')">
                            Organization required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="right-box">
                    <mat-form-field [ngClass]="{'disabled-cursor': triggerForm.disabled}">
                        <mat-label [ngClass]="{'disabled-cursor': triggerForm.disabled}">Repo url/ Repo
                            pattern</mat-label>
                        <input type="url" #url formControlName="repoPtrn" matInput
                            [ngClass]="{'disabled-cursor': triggerForm.disabled}">
                        <mat-error *ngIf="triggerForm.controls['repoPtrn'].errors?.['required'] == true">
                            Repo url/ repo pattern required
                        </mat-error>
                        <mat-error *ngIf="triggerForm.controls['repoPtrn'].errors?.['isValidRegex']">
                            Enter a valid repo url or repo pattern
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="pd-top-4">
                <div fxLayout="column" class="width100 pad-left-16 pad-right-16">
                    <mat-form-field appearance="fill" [ngClass]="{'disabled-cursor': triggerForm.disabled}">
                        <mat-label [ngClass]="{'disabled-cursor': triggerForm.disabled}">Branch</mat-label>
                        <input type="url" #url formControlName="branch" matInput
                            [ngClass]="{'disabled-cursor': triggerForm.disabled}">
                        <mat-error *ngIf="triggerForm.get('branch')?.hasError('required')">
                            Branch required
                        </mat-error>
                        <mat-error *ngIf="triggerForm.get('branch')?.errors?.['isValidRegex']">
                            Enter valid branch
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-card>
        <mat-card class="trigger-artifact-card">
            <div class="eventAction">
                <div class="left">
                    <mat-form-field appearance="fill" [ngClass]="{'disabled-cursor': triggerForm.disabled}"
                        class="mat-form-field">
                        <mat-label [ngClass]="{'disabled-cursor': triggerForm.disabled}">Event</mat-label>
                        <mat-select formControlName="event" (selectionChange)="onEventSelection($event.value)"
                            (closed)="onEventPanelClose()">
                            <mat-form-field class="mat-form-field search-box">
                                <input matInput [formControl]="eventFilterControl" type="text" name="event-filter-options"
                                    id="event-filter-options" placeholder="Search" (keydown)="$event.stopPropagation()">
                            </mat-form-field>
                            <div class="dropdown_panel">
                            <mat-option *ngFor="let evnt of filteredEventOptions | async" [value]="evnt.id">
                                {{ evnt.name }}
                            </mat-option>
                            </div>
                        </mat-select>
                        <mat-error *ngIf="triggerForm.controls['event'].errors?.['required']">Event
                            required</mat-error>
                    </mat-form-field>
                </div>
                <div class="right">
                    <mat-form-field [ngClass]="{'disabled-cursor': triggerForm.disabled}" class="mat-form-field">
                        <mat-label>Select Action</mat-label>
                        <mat-select formControlName="action" (closed)="onPanelClose()" multiple
                            (focus)="onInputFocus('actions')" #selectMult>
                            <mat-form-field class="mat-form-field search-box">
                                <input matInput [formControl]="filterControl" type="text" name="filter-options"
                                    id="filter-options" placeholder="Search">
                            </mat-form-field>
                            <div class="dropdown_panel">
                            <!-- "Select All" option -->
                            <div class="select-all">
                                <mat-checkbox color="primary" [(ngModel)]="allSelected"
                                    [ngModelOptions]="{standalone: true}" (change)="toggleAllSelection()">Select
                                    all</mat-checkbox>
                            </div>
                            <mat-option (click)="optionClick()" *ngFor="let option of filteredActions | async"
                                [value]="option.id" >
                                {{option.name}}
                            </mat-option>
                        </div>
                        </mat-select>
                        <mat-error *ngIf="triggerForm.controls['action'].errors?.['required']">Action
                            required</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-card>
        <div formGroupName="artifact">
            <mat-card class="trigger-artifact-card">
                <div class="row-box">
                    <div class="left-box">
                        <mat-form-field appearance="fill" class="child-content readonly-wrapper"
                            [ngClass]="{'disabled-cursor': triggerForm.disabled}">
                            <mat-label [ngClass]="{'disabled-cursor': triggerForm.disabled}">Input artifact</mat-label>
                            <mat-select formControlName="inputArtifact">
                                <mat-option value="artifact1"> JFrog</mat-option>
                            </mat-select>
                            <mat-error>
                                Input required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="right-box">
                        <mat-form-field class="child-content readonly-wrapper"
                            [ngClass]="{'disabled-cursor': triggerForm.disabled}">
                            <mat-label [ngClass]="{'disabled-cursor': triggerForm.disabled}">Repository</mat-label>
                            <input type="text" formControlName="inputArtifactRepo" matInput
                                [ngClass]="{'disabled-cursor': triggerForm.disabled}" />
                            <mat-error
                                *ngIf="triggerForm.get('artifact.inputArtifactRepo')?.errors?.['required'] == true">
                                Url required
                            </mat-error>
                            <mat-error *ngIf="triggerForm.get('artifact.inputArtifactRepo')?.errors?.['pattern']">
                                Enter valid url
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </mat-card>
            <mat-card class="trigger-artifact-card">
                <div class="row-box">
                    <div class="left-box">
                        <mat-form-field appearance="fill" class="child-content readonly-wrapper"
                            [ngClass]="{'disabled-cursor': triggerForm.disabled}">
                            <mat-label [ngClass]="{'disabled-cursor': triggerForm.disabled}">Output artifact</mat-label>
                            <mat-select formControlName="outputArtifact">
                                <mat-option value="dev"> JFrog</mat-option>
                            </mat-select>
                            <mat-error>
                                Output required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="right-box">
                        <mat-form-field class="child-content readonly-wrapper"
                            [ngClass]="{'disabled-cursor': triggerForm.disabled}">
                            <mat-label [ngClass]="{'disabled-cursor': triggerForm.disabled}">Repository</mat-label>
                            <input type="text" formControlName="outputArtifactRepo" matInput
                                [ngClass]="{'disabled-cursor': triggerForm.disabled}" />
                            <mat-error
                                *ngIf="triggerForm.get('artifact.outputArtifactRepo')?.errors?.['required'] == true">
                                Url required
                            </mat-error>
                            <mat-error *ngIf="triggerForm.get('artifact.outputArtifactRepo')?.errors?.['pattern']">
                                Enter valid url
                            </mat-error>

                        </mat-form-field>
                    </div>
                </div>
            </mat-card>
        </div>
    </form>


</div>